<article>
  <!-- Table si est un utilisateur Anett -->
  <table hideIfNot="ROLE_ANETT" mat-table [dataSource]="dataSource">
    <ng-container *ngFor="let column of columns">
      <ng-container matColumnDef="{{column.id}}">
        <ng-container>
          <ng-container *ngIf="column.id ==  'qt_sem_1_traitees'">
            <th mat-header-cell *matHeaderCellDef colspan="5">{{ column.libelle }}</th>
          </ng-container>
          <ng-container *ngIf="column.id !=  'qt_sem_1_traitees'">
            <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
          </ng-container>
          <td mat-cell *matCellDef="let element">{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
    </ng-container>
    <tr mat-header-row
      *matHeaderRowDef="['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_1_traitees', 'cal', 'qt_mab', 'qt_theo', 'stock', 'qt_diff']">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumnsAnett;"></tr>
  </table>
  <!-- Table si n'est pas un utilisateur Anett -->
  <table hideIfNot="!ROLE_ANETT" mat-table [dataSource]="dataSource">
    <ng-container *ngFor="let column of columns">
      <ng-container matColumnDef="{{column.id}}">
        <ng-container>
          <ng-container *ngIf="column.id ==  'qt_sem_1_traitees'">
            <th mat-header-cell *matHeaderCellDef colspan="5">{{ column.libelle }}</th>
          </ng-container>
          <ng-container *ngIf="column.id !=  'qt_sem_1_traitees'">
            <th mat-header-cell *matHeaderCellDef>{{ column.libelle }}</th>
          </ng-container>
          <td mat-cell *matCellDef="let element">{{ element[column.id] }}</td>
        </ng-container>
      </ng-container>
    </ng-container>
    <tr mat-header-row
      *matHeaderRowDef="['codeArticle', 'libelleArticle', 'qt_sem', 'tx_rot', 'qt_sem_1_traitees', 'qt_mab', 'qt_theo', 'stock', 'qt_diff']">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</article>